import {
  __commonJS
} from "./chunk-J43GMYXM.js";

// node_modules/.pnpm/node-fetch@2.6.7/node_modules/node-fetch/browser.js
var require_browser = __commonJS({
  "node_modules/.pnpm/node-fetch@2.6.7/node_modules/node-fetch/browser.js"(exports, module2) {
    "use strict";
    var getGlobal = function() {
      if (typeof self !== "undefined") {
        return self;
      }
      if (typeof window !== "undefined") {
        return window;
      }
      if (typeof global2 !== "undefined") {
        return global2;
      }
      throw new Error("unable to locate global object");
    };
    var global2 = getGlobal();
    module2.exports = exports = global2.fetch;
    if (global2.fetch) {
      exports.default = global2.fetch.bind(global2);
    }
    exports.Headers = global2.Headers;
    exports.Request = global2.Request;
    exports.Response = global2.Response;
  }
});

// browser-external:crypto
var require_crypto = __commonJS({
  "browser-external:crypto"(exports, module2) {
    module2.exports = {};
  }
});

// node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/shams.js
var require_shams = __commonJS({
  "node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/shams.js"(exports, module2) {
    "use strict";
    module2.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// node_modules/.pnpm/has-tostringtag@1.0.0/node_modules/has-tostringtag/shams.js
var require_shams2 = __commonJS({
  "node_modules/.pnpm/has-tostringtag@1.0.0/node_modules/has-tostringtag/shams.js"(exports, module2) {
    "use strict";
    var hasSymbols = require_shams();
    module2.exports = function hasToStringTagShams() {
      return hasSymbols() && !!Symbol.toStringTag;
    };
  }
});

// node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/index.js
var require_has_symbols = __commonJS({
  "node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/index.js"(exports, module2) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module2.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// node_modules/.pnpm/function-bind@1.1.1/node_modules/function-bind/implementation.js
var require_implementation = __commonJS({
  "node_modules/.pnpm/function-bind@1.1.1/node_modules/function-bind/implementation.js"(exports, module2) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var slice = Array.prototype.slice;
    var toStr = Object.prototype.toString;
    var funcType = "[object Function]";
    module2.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args = slice.call(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result = target.apply(
            this,
            args.concat(slice.call(arguments))
          );
          if (Object(result) === result) {
            return result;
          }
          return this;
        } else {
          return target.apply(
            that,
            args.concat(slice.call(arguments))
          );
        }
      };
      var boundLength = Math.max(0, target.length - args.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }
      bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// node_modules/.pnpm/function-bind@1.1.1/node_modules/function-bind/index.js
var require_function_bind = __commonJS({
  "node_modules/.pnpm/function-bind@1.1.1/node_modules/function-bind/index.js"(exports, module2) {
    "use strict";
    var implementation = require_implementation();
    module2.exports = Function.prototype.bind || implementation;
  }
});

// node_modules/.pnpm/has@1.0.3/node_modules/has/src/index.js
var require_src = __commonJS({
  "node_modules/.pnpm/has@1.0.3/node_modules/has/src/index.js"(exports, module2) {
    "use strict";
    var bind = require_function_bind();
    module2.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
  }
});

// node_modules/.pnpm/get-intrinsic@1.1.2/node_modules/get-intrinsic/index.js
var require_get_intrinsic = __commonJS({
  "node_modules/.pnpm/get-intrinsic@1.1.2/node_modules/get-intrinsic/index.js"(exports, module2) {
    "use strict";
    var undefined2;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var getProto = Object.getPrototypeOf || function(x) {
      return x.__proto__;
    };
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    var doEval = function doEval2(name) {
      var value;
      if (name === "%AsyncFunction%") {
        value = getEvalledConstructor("async function () {}");
      } else if (name === "%GeneratorFunction%") {
        value = getEvalledConstructor("function* () {}");
      } else if (name === "%AsyncGeneratorFunction%") {
        value = getEvalledConstructor("async function* () {}");
      } else if (name === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value = fn.prototype;
        }
      } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen) {
          value = getProto(gen.prototype);
        }
      }
      INTRINSICS[name] = value;
      return value;
    };
    var LEGACY_ALIASES = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_src();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result = [];
      $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
      });
      return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
      var intrinsicName = name;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) {
          value = doEval(intrinsicName);
        }
        if (typeof value === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value
        };
      }
      throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    module2.exports = function GetIntrinsic(name, allowMissing) {
      if (typeof name !== "string" || name.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/g, name) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath(name);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value = INTRINSICS[intrinsicRealName];
        } else if (value != null) {
          if (!(part in value)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value = desc.get;
            } else {
              value = value[part];
            }
          } else {
            isOwn = hasOwn(value, part);
            value = value[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value;
          }
        }
      }
      return value;
    };
  }
});

// node_modules/.pnpm/call-bind@1.0.2/node_modules/call-bind/index.js
var require_call_bind = __commonJS({
  "node_modules/.pnpm/call-bind@1.0.2/node_modules/call-bind/index.js"(exports, module2) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = null;
      }
    }
    module2.exports = function callBind(originalFunction) {
      var func = $reflectApply(bind, $call, arguments);
      if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) {
          $defineProperty(
            func,
            "length",
            { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
          );
        }
      }
      return func;
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module2.exports, "apply", { value: applyBind });
    } else {
      module2.exports.apply = applyBind;
    }
  }
});

// node_modules/.pnpm/call-bind@1.0.2/node_modules/call-bind/callBound.js
var require_callBound = __commonJS({
  "node_modules/.pnpm/call-bind@1.0.2/node_modules/call-bind/callBound.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module2.exports = function callBoundIntrinsic(name, allowMissing) {
      var intrinsic = GetIntrinsic(name, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// node_modules/.pnpm/is-arguments@1.1.1/node_modules/is-arguments/index.js
var require_is_arguments = __commonJS({
  "node_modules/.pnpm/is-arguments@1.1.1/node_modules/is-arguments/index.js"(exports, module2) {
    "use strict";
    var hasToStringTag = require_shams2()();
    var callBound = require_callBound();
    var $toString = callBound("Object.prototype.toString");
    var isStandardArguments = function isArguments(value) {
      if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) {
        return false;
      }
      return $toString(value) === "[object Arguments]";
    };
    var isLegacyArguments = function isArguments(value) {
      if (isStandardArguments(value)) {
        return true;
      }
      return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
    };
    var supportsStandardArguments = function() {
      return isStandardArguments(arguments);
    }();
    isStandardArguments.isLegacyArguments = isLegacyArguments;
    module2.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
  }
});

// node_modules/.pnpm/is-generator-function@1.0.10/node_modules/is-generator-function/index.js
var require_is_generator_function = __commonJS({
  "node_modules/.pnpm/is-generator-function@1.0.10/node_modules/is-generator-function/index.js"(exports, module2) {
    "use strict";
    var toStr = Object.prototype.toString;
    var fnToStr = Function.prototype.toString;
    var isFnRegex = /^\s*(?:function)?\*/;
    var hasToStringTag = require_shams2()();
    var getProto = Object.getPrototypeOf;
    var getGeneratorFunc = function() {
      if (!hasToStringTag) {
        return false;
      }
      try {
        return Function("return function*() {}")();
      } catch (e) {
      }
    };
    var GeneratorFunction;
    module2.exports = function isGeneratorFunction(fn) {
      if (typeof fn !== "function") {
        return false;
      }
      if (isFnRegex.test(fnToStr.call(fn))) {
        return true;
      }
      if (!hasToStringTag) {
        var str = toStr.call(fn);
        return str === "[object GeneratorFunction]";
      }
      if (!getProto) {
        return false;
      }
      if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
      }
      return getProto(fn) === GeneratorFunction;
    };
  }
});

// node_modules/.pnpm/is-callable@1.2.4/node_modules/is-callable/index.js
var require_is_callable = __commonJS({
  "node_modules/.pnpm/is-callable@1.2.4/node_modules/is-callable/index.js"(exports, module2) {
    "use strict";
    var fnToStr = Function.prototype.toString;
    var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
    var badArrayLike;
    var isCallableMarker;
    if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
      try {
        badArrayLike = Object.defineProperty({}, "length", {
          get: function() {
            throw isCallableMarker;
          }
        });
        isCallableMarker = {};
        reflectApply(function() {
          throw 42;
        }, null, badArrayLike);
      } catch (_) {
        if (_ !== isCallableMarker) {
          reflectApply = null;
        }
      }
    } else {
      reflectApply = null;
    }
    var constructorRegex = /^\s*class\b/;
    var isES6ClassFn = function isES6ClassFunction(value) {
      try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
      } catch (e) {
        return false;
      }
    };
    var tryFunctionObject = function tryFunctionToStr(value) {
      try {
        if (isES6ClassFn(value)) {
          return false;
        }
        fnToStr.call(value);
        return true;
      } catch (e) {
        return false;
      }
    };
    var toStr = Object.prototype.toString;
    var fnClass = "[object Function]";
    var genClass = "[object GeneratorFunction]";
    var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
    var documentDotAll = typeof document === "object" && typeof document.all === "undefined" && document.all !== void 0 ? document.all : {};
    module2.exports = reflectApply ? function isCallable(value) {
      if (value === documentDotAll) {
        return true;
      }
      if (!value) {
        return false;
      }
      if (typeof value !== "function" && typeof value !== "object") {
        return false;
      }
      if (typeof value === "function" && !value.prototype) {
        return true;
      }
      try {
        reflectApply(value, null, badArrayLike);
      } catch (e) {
        if (e !== isCallableMarker) {
          return false;
        }
      }
      return !isES6ClassFn(value);
    } : function isCallable(value) {
      if (value === documentDotAll) {
        return true;
      }
      if (!value) {
        return false;
      }
      if (typeof value !== "function" && typeof value !== "object") {
        return false;
      }
      if (typeof value === "function" && !value.prototype) {
        return true;
      }
      if (hasToStringTag) {
        return tryFunctionObject(value);
      }
      if (isES6ClassFn(value)) {
        return false;
      }
      var strClass = toStr.call(value);
      return strClass === fnClass || strClass === genClass;
    };
  }
});

// node_modules/.pnpm/for-each@0.3.3/node_modules/for-each/index.js
var require_for_each = __commonJS({
  "node_modules/.pnpm/for-each@0.3.3/node_modules/for-each/index.js"(exports, module2) {
    "use strict";
    var isCallable = require_is_callable();
    var toStr = Object.prototype.toString;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var forEachArray = function forEachArray2(array, iterator, receiver) {
      for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
          if (receiver == null) {
            iterator(array[i], i, array);
          } else {
            iterator.call(receiver, array[i], i, array);
          }
        }
      }
    };
    var forEachString = function forEachString2(string, iterator, receiver) {
      for (var i = 0, len = string.length; i < len; i++) {
        if (receiver == null) {
          iterator(string.charAt(i), i, string);
        } else {
          iterator.call(receiver, string.charAt(i), i, string);
        }
      }
    };
    var forEachObject = function forEachObject2(object, iterator, receiver) {
      for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
          if (receiver == null) {
            iterator(object[k], k, object);
          } else {
            iterator.call(receiver, object[k], k, object);
          }
        }
      }
    };
    var forEach = function forEach2(list, iterator, thisArg) {
      if (!isCallable(iterator)) {
        throw new TypeError("iterator must be a function");
      }
      var receiver;
      if (arguments.length >= 3) {
        receiver = thisArg;
      }
      if (toStr.call(list) === "[object Array]") {
        forEachArray(list, iterator, receiver);
      } else if (typeof list === "string") {
        forEachString(list, iterator, receiver);
      } else {
        forEachObject(list, iterator, receiver);
      }
    };
    module2.exports = forEach;
  }
});

// node_modules/.pnpm/available-typed-arrays@1.0.5/node_modules/available-typed-arrays/index.js
var require_available_typed_arrays = __commonJS({
  "node_modules/.pnpm/available-typed-arrays@1.0.5/node_modules/available-typed-arrays/index.js"(exports, module2) {
    "use strict";
    var possibleNames = [
      "BigInt64Array",
      "BigUint64Array",
      "Float32Array",
      "Float64Array",
      "Int16Array",
      "Int32Array",
      "Int8Array",
      "Uint16Array",
      "Uint32Array",
      "Uint8Array",
      "Uint8ClampedArray"
    ];
    var g = typeof globalThis === "undefined" ? global : globalThis;
    module2.exports = function availableTypedArrays() {
      var out = [];
      for (var i = 0; i < possibleNames.length; i++) {
        if (typeof g[possibleNames[i]] === "function") {
          out[out.length] = possibleNames[i];
        }
      }
      return out;
    };
  }
});

// node_modules/.pnpm/es-abstract@1.20.1/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js
var require_getOwnPropertyDescriptor = __commonJS({
  "node_modules/.pnpm/es-abstract@1.20.1/node_modules/es-abstract/helpers/getOwnPropertyDescriptor.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    if ($gOPD) {
      try {
        $gOPD([], "length");
      } catch (e) {
        $gOPD = null;
      }
    }
    module2.exports = $gOPD;
  }
});

// node_modules/.pnpm/is-typed-array@1.1.9/node_modules/is-typed-array/index.js
var require_is_typed_array = __commonJS({
  "node_modules/.pnpm/is-typed-array@1.1.9/node_modules/is-typed-array/index.js"(exports, module2) {
    "use strict";
    var forEach = require_for_each();
    var availableTypedArrays = require_available_typed_arrays();
    var callBound = require_callBound();
    var $toString = callBound("Object.prototype.toString");
    var hasToStringTag = require_shams2()();
    var g = typeof globalThis === "undefined" ? global : globalThis;
    var typedArrays = availableTypedArrays();
    var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i] === value) {
          return i;
        }
      }
      return -1;
    };
    var $slice = callBound("String.prototype.slice");
    var toStrTags = {};
    var gOPD = require_getOwnPropertyDescriptor();
    var getPrototypeOf = Object.getPrototypeOf;
    if (hasToStringTag && gOPD && getPrototypeOf) {
      forEach(typedArrays, function(typedArray) {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
          var proto = getPrototypeOf(arr);
          var descriptor = gOPD(proto, Symbol.toStringTag);
          if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            descriptor = gOPD(superProto, Symbol.toStringTag);
          }
          toStrTags[typedArray] = descriptor.get;
        }
      });
    }
    var tryTypedArrays = function tryAllTypedArrays(value) {
      var anyTrue = false;
      forEach(toStrTags, function(getter, typedArray) {
        if (!anyTrue) {
          try {
            anyTrue = getter.call(value) === typedArray;
          } catch (e) {
          }
        }
      });
      return anyTrue;
    };
    module2.exports = function isTypedArray(value) {
      if (!value || typeof value !== "object") {
        return false;
      }
      if (!hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $slice($toString(value), 8, -1);
        return $indexOf(typedArrays, tag) > -1;
      }
      if (!gOPD) {
        return false;
      }
      return tryTypedArrays(value);
    };
  }
});

// node_modules/.pnpm/which-typed-array@1.1.8/node_modules/which-typed-array/index.js
var require_which_typed_array = __commonJS({
  "node_modules/.pnpm/which-typed-array@1.1.8/node_modules/which-typed-array/index.js"(exports, module2) {
    "use strict";
    var forEach = require_for_each();
    var availableTypedArrays = require_available_typed_arrays();
    var callBound = require_callBound();
    var $toString = callBound("Object.prototype.toString");
    var hasToStringTag = require_shams2()();
    var g = typeof globalThis === "undefined" ? global : globalThis;
    var typedArrays = availableTypedArrays();
    var $slice = callBound("String.prototype.slice");
    var toStrTags = {};
    var gOPD = require_getOwnPropertyDescriptor();
    var getPrototypeOf = Object.getPrototypeOf;
    if (hasToStringTag && gOPD && getPrototypeOf) {
      forEach(typedArrays, function(typedArray) {
        if (typeof g[typedArray] === "function") {
          var arr = new g[typedArray]();
          if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
              var superProto = getPrototypeOf(proto);
              descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            toStrTags[typedArray] = descriptor.get;
          }
        }
      });
    }
    var tryTypedArrays = function tryAllTypedArrays(value) {
      var foundName = false;
      forEach(toStrTags, function(getter, typedArray) {
        if (!foundName) {
          try {
            var name = getter.call(value);
            if (name === typedArray) {
              foundName = name;
            }
          } catch (e) {
          }
        }
      });
      return foundName;
    };
    var isTypedArray = require_is_typed_array();
    module2.exports = function whichTypedArray(value) {
      if (!isTypedArray(value)) {
        return false;
      }
      if (!hasToStringTag || !(Symbol.toStringTag in value)) {
        return $slice($toString(value), 8, -1);
      }
      return tryTypedArrays(value);
    };
  }
});

// node_modules/.pnpm/util@0.12.4/node_modules/util/support/types.js
var require_types = __commonJS({
  "node_modules/.pnpm/util@0.12.4/node_modules/util/support/types.js"(exports) {
    "use strict";
    var isArgumentsObject = require_is_arguments();
    var isGeneratorFunction = require_is_generator_function();
    var whichTypedArray = require_which_typed_array();
    var isTypedArray = require_is_typed_array();
    function uncurryThis(f) {
      return f.call.bind(f);
    }
    var BigIntSupported = typeof BigInt !== "undefined";
    var SymbolSupported = typeof Symbol !== "undefined";
    var ObjectToString = uncurryThis(Object.prototype.toString);
    var numberValue = uncurryThis(Number.prototype.valueOf);
    var stringValue = uncurryThis(String.prototype.valueOf);
    var booleanValue = uncurryThis(Boolean.prototype.valueOf);
    if (BigIntSupported) {
      bigIntValue = uncurryThis(BigInt.prototype.valueOf);
    }
    var bigIntValue;
    if (SymbolSupported) {
      symbolValue = uncurryThis(Symbol.prototype.valueOf);
    }
    var symbolValue;
    function checkBoxedPrimitive(value, prototypeValueOf) {
      if (typeof value !== "object") {
        return false;
      }
      try {
        prototypeValueOf(value);
        return true;
      } catch (e) {
        return false;
      }
    }
    exports.isArgumentsObject = isArgumentsObject;
    exports.isGeneratorFunction = isGeneratorFunction;
    exports.isTypedArray = isTypedArray;
    function isPromise(input) {
      return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
    }
    exports.isPromise = isPromise;
    function isArrayBufferView(value) {
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        return ArrayBuffer.isView(value);
      }
      return isTypedArray(value) || isDataView(value);
    }
    exports.isArrayBufferView = isArrayBufferView;
    function isUint8Array(value) {
      return whichTypedArray(value) === "Uint8Array";
    }
    exports.isUint8Array = isUint8Array;
    function isUint8ClampedArray(value) {
      return whichTypedArray(value) === "Uint8ClampedArray";
    }
    exports.isUint8ClampedArray = isUint8ClampedArray;
    function isUint16Array(value) {
      return whichTypedArray(value) === "Uint16Array";
    }
    exports.isUint16Array = isUint16Array;
    function isUint32Array(value) {
      return whichTypedArray(value) === "Uint32Array";
    }
    exports.isUint32Array = isUint32Array;
    function isInt8Array(value) {
      return whichTypedArray(value) === "Int8Array";
    }
    exports.isInt8Array = isInt8Array;
    function isInt16Array(value) {
      return whichTypedArray(value) === "Int16Array";
    }
    exports.isInt16Array = isInt16Array;
    function isInt32Array(value) {
      return whichTypedArray(value) === "Int32Array";
    }
    exports.isInt32Array = isInt32Array;
    function isFloat32Array(value) {
      return whichTypedArray(value) === "Float32Array";
    }
    exports.isFloat32Array = isFloat32Array;
    function isFloat64Array(value) {
      return whichTypedArray(value) === "Float64Array";
    }
    exports.isFloat64Array = isFloat64Array;
    function isBigInt64Array(value) {
      return whichTypedArray(value) === "BigInt64Array";
    }
    exports.isBigInt64Array = isBigInt64Array;
    function isBigUint64Array(value) {
      return whichTypedArray(value) === "BigUint64Array";
    }
    exports.isBigUint64Array = isBigUint64Array;
    function isMapToString(value) {
      return ObjectToString(value) === "[object Map]";
    }
    isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
    function isMap(value) {
      if (typeof Map === "undefined") {
        return false;
      }
      return isMapToString.working ? isMapToString(value) : value instanceof Map;
    }
    exports.isMap = isMap;
    function isSetToString(value) {
      return ObjectToString(value) === "[object Set]";
    }
    isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
    function isSet(value) {
      if (typeof Set === "undefined") {
        return false;
      }
      return isSetToString.working ? isSetToString(value) : value instanceof Set;
    }
    exports.isSet = isSet;
    function isWeakMapToString(value) {
      return ObjectToString(value) === "[object WeakMap]";
    }
    isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
    function isWeakMap(value) {
      if (typeof WeakMap === "undefined") {
        return false;
      }
      return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
    }
    exports.isWeakMap = isWeakMap;
    function isWeakSetToString(value) {
      return ObjectToString(value) === "[object WeakSet]";
    }
    isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
    function isWeakSet(value) {
      return isWeakSetToString(value);
    }
    exports.isWeakSet = isWeakSet;
    function isArrayBufferToString(value) {
      return ObjectToString(value) === "[object ArrayBuffer]";
    }
    isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
    function isArrayBuffer(value) {
      if (typeof ArrayBuffer === "undefined") {
        return false;
      }
      return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    exports.isArrayBuffer = isArrayBuffer;
    function isDataViewToString(value) {
      return ObjectToString(value) === "[object DataView]";
    }
    isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function isDataView(value) {
      if (typeof DataView === "undefined") {
        return false;
      }
      return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
    }
    exports.isDataView = isDataView;
    var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : void 0;
    function isSharedArrayBufferToString(value) {
      return ObjectToString(value) === "[object SharedArrayBuffer]";
    }
    function isSharedArrayBuffer(value) {
      if (typeof SharedArrayBufferCopy === "undefined") {
        return false;
      }
      if (typeof isSharedArrayBufferToString.working === "undefined") {
        isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
      }
      return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
    }
    exports.isSharedArrayBuffer = isSharedArrayBuffer;
    function isAsyncFunction(value) {
      return ObjectToString(value) === "[object AsyncFunction]";
    }
    exports.isAsyncFunction = isAsyncFunction;
    function isMapIterator(value) {
      return ObjectToString(value) === "[object Map Iterator]";
    }
    exports.isMapIterator = isMapIterator;
    function isSetIterator(value) {
      return ObjectToString(value) === "[object Set Iterator]";
    }
    exports.isSetIterator = isSetIterator;
    function isGeneratorObject(value) {
      return ObjectToString(value) === "[object Generator]";
    }
    exports.isGeneratorObject = isGeneratorObject;
    function isWebAssemblyCompiledModule(value) {
      return ObjectToString(value) === "[object WebAssembly.Module]";
    }
    exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
    function isNumberObject(value) {
      return checkBoxedPrimitive(value, numberValue);
    }
    exports.isNumberObject = isNumberObject;
    function isStringObject(value) {
      return checkBoxedPrimitive(value, stringValue);
    }
    exports.isStringObject = isStringObject;
    function isBooleanObject(value) {
      return checkBoxedPrimitive(value, booleanValue);
    }
    exports.isBooleanObject = isBooleanObject;
    function isBigIntObject(value) {
      return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
    }
    exports.isBigIntObject = isBigIntObject;
    function isSymbolObject(value) {
      return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
    }
    exports.isSymbolObject = isSymbolObject;
    function isBoxedPrimitive(value) {
      return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
    }
    exports.isBoxedPrimitive = isBoxedPrimitive;
    function isAnyArrayBuffer(value) {
      return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
    }
    exports.isAnyArrayBuffer = isAnyArrayBuffer;
    ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(method) {
      Object.defineProperty(exports, method, {
        enumerable: false,
        value: function() {
          throw new Error(method + " is not supported in userland");
        }
      });
    });
  }
});

// node_modules/.pnpm/util@0.12.4/node_modules/util/support/isBufferBrowser.js
var require_isBufferBrowser = __commonJS({
  "node_modules/.pnpm/util@0.12.4/node_modules/util/support/isBufferBrowser.js"(exports, module2) {
    module2.exports = function isBuffer(arg) {
      return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
    };
  }
});

// node_modules/.pnpm/inherits@2.0.4/node_modules/inherits/inherits_browser.js
var require_inherits_browser = __commonJS({
  "node_modules/.pnpm/inherits@2.0.4/node_modules/inherits/inherits_browser.js"(exports, module2) {
    if (typeof Object.create === "function") {
      module2.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        }
      };
    } else {
      module2.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function() {
          };
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }
      };
    }
  }
});

// node_modules/.pnpm/util@0.12.4/node_modules/util/util.js
var require_util = __commonJS({
  "node_modules/.pnpm/util@0.12.4/node_modules/util/util.js"(exports) {
    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
      var keys = Object.keys(obj);
      var descriptors = {};
      for (var i = 0; i < keys.length; i++) {
        descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
      }
      return descriptors;
    };
    var formatRegExp = /%[sdj%]/g;
    exports.format = function(f) {
      if (!isString(f)) {
        var objects = [];
        for (var i = 0; i < arguments.length; i++) {
          objects.push(inspect(arguments[i]));
        }
        return objects.join(" ");
      }
      var i = 1;
      var args = arguments;
      var len = args.length;
      var str = String(f).replace(formatRegExp, function(x2) {
        if (x2 === "%%")
          return "%";
        if (i >= len)
          return x2;
        switch (x2) {
          case "%s":
            return String(args[i++]);
          case "%d":
            return Number(args[i++]);
          case "%j":
            try {
              return JSON.stringify(args[i++]);
            } catch (_) {
              return "[Circular]";
            }
          default:
            return x2;
        }
      });
      for (var x = args[i]; i < len; x = args[++i]) {
        if (isNull(x) || !isObject(x)) {
          str += " " + x;
        } else {
          str += " " + inspect(x);
        }
      }
      return str;
    };
    exports.deprecate = function(fn, msg) {
      if (typeof process !== "undefined" && process.noDeprecation === true) {
        return fn;
      }
      if (typeof process === "undefined") {
        return function() {
          return exports.deprecate(fn, msg).apply(this, arguments);
        };
      }
      var warned = false;
      function deprecated() {
        if (!warned) {
          if (process.throwDeprecation) {
            throw new Error(msg);
          } else if (process.traceDeprecation) {
            console.trace(msg);
          } else {
            console.error(msg);
          }
          warned = true;
        }
        return fn.apply(this, arguments);
      }
      return deprecated;
    };
    var debugs = {};
    var debugEnvRegex = /^$/;
    if (process.env.NODE_DEBUG) {
      debugEnv = process.env.NODE_DEBUG;
      debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
      debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
    }
    var debugEnv;
    exports.debuglog = function(set) {
      set = set.toUpperCase();
      if (!debugs[set]) {
        if (debugEnvRegex.test(set)) {
          var pid = process.pid;
          debugs[set] = function() {
            var msg = exports.format.apply(exports, arguments);
            console.error("%s %d: %s", set, pid, msg);
          };
        } else {
          debugs[set] = function() {
          };
        }
      }
      return debugs[set];
    };
    function inspect(obj, opts) {
      var ctx = {
        seen: [],
        stylize: stylizeNoColor
      };
      if (arguments.length >= 3)
        ctx.depth = arguments[2];
      if (arguments.length >= 4)
        ctx.colors = arguments[3];
      if (isBoolean(opts)) {
        ctx.showHidden = opts;
      } else if (opts) {
        exports._extend(ctx, opts);
      }
      if (isUndefined(ctx.showHidden))
        ctx.showHidden = false;
      if (isUndefined(ctx.depth))
        ctx.depth = 2;
      if (isUndefined(ctx.colors))
        ctx.colors = false;
      if (isUndefined(ctx.customInspect))
        ctx.customInspect = true;
      if (ctx.colors)
        ctx.stylize = stylizeWithColor;
      return formatValue(ctx, obj, ctx.depth);
    }
    exports.inspect = inspect;
    inspect.colors = {
      "bold": [1, 22],
      "italic": [3, 23],
      "underline": [4, 24],
      "inverse": [7, 27],
      "white": [37, 39],
      "grey": [90, 39],
      "black": [30, 39],
      "blue": [34, 39],
      "cyan": [36, 39],
      "green": [32, 39],
      "magenta": [35, 39],
      "red": [31, 39],
      "yellow": [33, 39]
    };
    inspect.styles = {
      "special": "cyan",
      "number": "yellow",
      "boolean": "yellow",
      "undefined": "grey",
      "null": "bold",
      "string": "green",
      "date": "magenta",
      "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
      var style = inspect.styles[styleType];
      if (style) {
        return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
      } else {
        return str;
      }
    }
    function stylizeNoColor(str, styleType) {
      return str;
    }
    function arrayToHash(array) {
      var hash = {};
      array.forEach(function(val, idx) {
        hash[val] = true;
      });
      return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
      if (ctx.customInspect && value && isFunction(value.inspect) && value.inspect !== exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) {
          ret = formatValue(ctx, ret, recurseTimes);
        }
        return ret;
      }
      var primitive = formatPrimitive(ctx, value);
      if (primitive) {
        return primitive;
      }
      var keys = Object.keys(value);
      var visibleKeys = arrayToHash(keys);
      if (ctx.showHidden) {
        keys = Object.getOwnPropertyNames(value);
      }
      if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) {
        return formatError(value);
      }
      if (keys.length === 0) {
        if (isFunction(value)) {
          var name = value.name ? ": " + value.name : "";
          return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        }
        if (isDate(value)) {
          return ctx.stylize(Date.prototype.toString.call(value), "date");
        }
        if (isError(value)) {
          return formatError(value);
        }
      }
      var base = "", array = false, braces = ["{", "}"];
      if (isArray(value)) {
        array = true;
        braces = ["[", "]"];
      }
      if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
      }
      if (isRegExp(value)) {
        base = " " + RegExp.prototype.toString.call(value);
      }
      if (isDate(value)) {
        base = " " + Date.prototype.toUTCString.call(value);
      }
      if (isError(value)) {
        base = " " + formatError(value);
      }
      if (keys.length === 0 && (!array || value.length == 0)) {
        return braces[0] + base + braces[1];
      }
      if (recurseTimes < 0) {
        if (isRegExp(value)) {
          return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        } else {
          return ctx.stylize("[Object]", "special");
        }
      }
      ctx.seen.push(value);
      var output;
      if (array) {
        output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
      } else {
        output = keys.map(function(key) {
          return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
      }
      ctx.seen.pop();
      return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
      if (isUndefined(value))
        return ctx.stylize("undefined", "undefined");
      if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
      }
      if (isNumber(value))
        return ctx.stylize("" + value, "number");
      if (isBoolean(value))
        return ctx.stylize("" + value, "boolean");
      if (isNull(value))
        return ctx.stylize("null", "null");
    }
    function formatError(value) {
      return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
      var output = [];
      for (var i = 0, l = value.length; i < l; ++i) {
        if (hasOwnProperty(value, String(i))) {
          output.push(formatProperty(
            ctx,
            value,
            recurseTimes,
            visibleKeys,
            String(i),
            true
          ));
        } else {
          output.push("");
        }
      }
      keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) {
          output.push(formatProperty(
            ctx,
            value,
            recurseTimes,
            visibleKeys,
            key,
            true
          ));
        }
      });
      return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
      var name, str, desc;
      desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
      if (desc.get) {
        if (desc.set) {
          str = ctx.stylize("[Getter/Setter]", "special");
        } else {
          str = ctx.stylize("[Getter]", "special");
        }
      } else {
        if (desc.set) {
          str = ctx.stylize("[Setter]", "special");
        }
      }
      if (!hasOwnProperty(visibleKeys, key)) {
        name = "[" + key + "]";
      }
      if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
          if (isNull(recurseTimes)) {
            str = formatValue(ctx, desc.value, null);
          } else {
            str = formatValue(ctx, desc.value, recurseTimes - 1);
          }
          if (str.indexOf("\n") > -1) {
            if (array) {
              str = str.split("\n").map(function(line) {
                return "  " + line;
              }).join("\n").substr(2);
            } else {
              str = "\n" + str.split("\n").map(function(line) {
                return "   " + line;
              }).join("\n");
            }
          }
        } else {
          str = ctx.stylize("[Circular]", "special");
        }
      }
      if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) {
          return str;
        }
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
          name = name.substr(1, name.length - 2);
          name = ctx.stylize(name, "name");
        } else {
          name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
          name = ctx.stylize(name, "string");
        }
      }
      return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
      var numLinesEst = 0;
      var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0)
          numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      if (length > 60) {
        return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
      }
      return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    }
    exports.types = require_types();
    function isArray(ar) {
      return Array.isArray(ar);
    }
    exports.isArray = isArray;
    function isBoolean(arg) {
      return typeof arg === "boolean";
    }
    exports.isBoolean = isBoolean;
    function isNull(arg) {
      return arg === null;
    }
    exports.isNull = isNull;
    function isNullOrUndefined(arg) {
      return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
      return typeof arg === "number";
    }
    exports.isNumber = isNumber;
    function isString(arg) {
      return typeof arg === "string";
    }
    exports.isString = isString;
    function isSymbol(arg) {
      return typeof arg === "symbol";
    }
    exports.isSymbol = isSymbol;
    function isUndefined(arg) {
      return arg === void 0;
    }
    exports.isUndefined = isUndefined;
    function isRegExp(re) {
      return isObject(re) && objectToString(re) === "[object RegExp]";
    }
    exports.isRegExp = isRegExp;
    exports.types.isRegExp = isRegExp;
    function isObject(arg) {
      return typeof arg === "object" && arg !== null;
    }
    exports.isObject = isObject;
    function isDate(d) {
      return isObject(d) && objectToString(d) === "[object Date]";
    }
    exports.isDate = isDate;
    exports.types.isDate = isDate;
    function isError(e) {
      return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
    }
    exports.isError = isError;
    exports.types.isNativeError = isError;
    function isFunction(arg) {
      return typeof arg === "function";
    }
    exports.isFunction = isFunction;
    function isPrimitive(arg) {
      return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || typeof arg === "undefined";
    }
    exports.isPrimitive = isPrimitive;
    exports.isBuffer = require_isBufferBrowser();
    function objectToString(o) {
      return Object.prototype.toString.call(o);
    }
    function pad(n) {
      return n < 10 ? "0" + n.toString(10) : n.toString(10);
    }
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function timestamp() {
      var d = new Date();
      var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
      ].join(":");
      return [d.getDate(), months[d.getMonth()], time].join(" ");
    }
    exports.log = function() {
      console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
    };
    exports.inherits = require_inherits_browser();
    exports._extend = function(origin, add) {
      if (!add || !isObject(add))
        return origin;
      var keys = Object.keys(add);
      var i = keys.length;
      while (i--) {
        origin[keys[i]] = add[keys[i]];
      }
      return origin;
    };
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
    exports.promisify = function promisify(original) {
      if (typeof original !== "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") {
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        }
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn,
          enumerable: false,
          writable: false,
          configurable: true
        });
        return fn;
      }
      function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
          promiseResolve = resolve;
          promiseReject = reject;
        });
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        args.push(function(err, value) {
          if (err) {
            promiseReject(err);
          } else {
            promiseResolve(value);
          }
        });
        try {
          original.apply(this, args);
        } catch (err) {
          promiseReject(err);
        }
        return promise;
      }
      Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
      if (kCustomPromisifiedSymbol)
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
          value: fn,
          enumerable: false,
          writable: false,
          configurable: true
        });
      return Object.defineProperties(
        fn,
        getOwnPropertyDescriptors(original)
      );
    };
    exports.promisify.custom = kCustomPromisifiedSymbol;
    function callbackifyOnRejected(reason, cb) {
      if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
      }
      return cb(reason);
    }
    function callbackify(original) {
      if (typeof original !== "function") {
        throw new TypeError('The "original" argument must be of type Function');
      }
      function callbackified() {
        var args = [];
        for (var i = 0; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") {
          throw new TypeError("The last argument must be of type Function");
        }
        var self2 = this;
        var cb = function() {
          return maybeCb.apply(self2, arguments);
        };
        original.apply(this, args).then(
          function(ret) {
            process.nextTick(cb.bind(null, null, ret));
          },
          function(rej) {
            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
          }
        );
      }
      Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
      Object.defineProperties(
        callbackified,
        getOwnPropertyDescriptors(original)
      );
      return callbackified;
    }
    exports.callbackify = callbackify;
  }
});

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/constants.js
var RPC = "rpc";
var UPLOAD = "upload";
var DOWNLOAD = "download";
var APP_AUTH = "app";
var USER_AUTH = "user";
var TEAM_AUTH = "team";
var NO_AUTH = "noauth";
var COOKIE = "cookie";
var DEFAULT_API_DOMAIN = "dropboxapi.com";
var DEFAULT_DOMAIN = "dropbox.com";
var TEST_DOMAIN_MAPPINGS = {
  api: "api",
  notify: "bolt",
  content: "api-content"
};

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/lib/routes.js
var routes = {};
routes.accountSetProfilePhoto = function(arg) {
  return this.request("account/set_profile_photo", arg, "user", "api", "rpc", "account_info.write");
};
routes.authTokenFromOauth1 = function(arg) {
  return this.request("auth/token/from_oauth1", arg, "app", "api", "rpc", null);
};
routes.authTokenRevoke = function() {
  return this.request("auth/token/revoke", null, "user", "api", "rpc", null);
};
routes.checkApp = function(arg) {
  return this.request("check/app", arg, "app", "api", "rpc", null);
};
routes.checkUser = function(arg) {
  return this.request("check/user", arg, "user", "api", "rpc", "account_info.read");
};
routes.contactsDeleteManualContacts = function() {
  return this.request("contacts/delete_manual_contacts", null, "user", "api", "rpc", "contacts.write");
};
routes.contactsDeleteManualContactsBatch = function(arg) {
  return this.request("contacts/delete_manual_contacts_batch", arg, "user", "api", "rpc", "contacts.write");
};
routes.filePropertiesPropertiesAdd = function(arg) {
  return this.request("file_properties/properties/add", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesPropertiesOverwrite = function(arg) {
  return this.request("file_properties/properties/overwrite", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesPropertiesRemove = function(arg) {
  return this.request("file_properties/properties/remove", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesPropertiesSearch = function(arg) {
  return this.request("file_properties/properties/search", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filePropertiesPropertiesSearchContinue = function(arg) {
  return this.request("file_properties/properties/search/continue", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filePropertiesPropertiesUpdate = function(arg) {
  return this.request("file_properties/properties/update", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesTemplatesAddForTeam = function(arg) {
  return this.request("file_properties/templates/add_for_team", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.filePropertiesTemplatesAddForUser = function(arg) {
  return this.request("file_properties/templates/add_for_user", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesTemplatesGetForTeam = function(arg) {
  return this.request("file_properties/templates/get_for_team", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.filePropertiesTemplatesGetForUser = function(arg) {
  return this.request("file_properties/templates/get_for_user", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filePropertiesTemplatesListForTeam = function() {
  return this.request("file_properties/templates/list_for_team", null, "team", "api", "rpc", "files.team_metadata.write");
};
routes.filePropertiesTemplatesListForUser = function() {
  return this.request("file_properties/templates/list_for_user", null, "user", "api", "rpc", "files.metadata.read");
};
routes.filePropertiesTemplatesRemoveForTeam = function(arg) {
  return this.request("file_properties/templates/remove_for_team", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.filePropertiesTemplatesRemoveForUser = function(arg) {
  return this.request("file_properties/templates/remove_for_user", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filePropertiesTemplatesUpdateForTeam = function(arg) {
  return this.request("file_properties/templates/update_for_team", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.filePropertiesTemplatesUpdateForUser = function(arg) {
  return this.request("file_properties/templates/update_for_user", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.fileRequestsCount = function() {
  return this.request("file_requests/count", null, "user", "api", "rpc", "file_requests.read");
};
routes.fileRequestsCreate = function(arg) {
  return this.request("file_requests/create", arg, "user", "api", "rpc", "file_requests.write");
};
routes.fileRequestsDelete = function(arg) {
  return this.request("file_requests/delete", arg, "user", "api", "rpc", "file_requests.write");
};
routes.fileRequestsDeleteAllClosed = function() {
  return this.request("file_requests/delete_all_closed", null, "user", "api", "rpc", "file_requests.write");
};
routes.fileRequestsGet = function(arg) {
  return this.request("file_requests/get", arg, "user", "api", "rpc", "file_requests.read");
};
routes.fileRequestsListV2 = function(arg) {
  return this.request("file_requests/list_v2", arg, "user", "api", "rpc", "file_requests.read");
};
routes.fileRequestsList = function() {
  return this.request("file_requests/list", null, "user", "api", "rpc", "file_requests.read");
};
routes.fileRequestsListContinue = function(arg) {
  return this.request("file_requests/list/continue", arg, "user", "api", "rpc", "file_requests.read");
};
routes.fileRequestsUpdate = function(arg) {
  return this.request("file_requests/update", arg, "user", "api", "rpc", "file_requests.write");
};
routes.filesAlphaGetMetadata = function(arg) {
  return this.request("files/alpha/get_metadata", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesAlphaUpload = function(arg) {
  return this.request("files/alpha/upload", arg, "user", "content", "upload", "files.content.write");
};
routes.filesCopyV2 = function(arg) {
  return this.request("files/copy_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopy = function(arg) {
  return this.request("files/copy", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyBatchV2 = function(arg) {
  return this.request("files/copy_batch_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyBatch = function(arg) {
  return this.request("files/copy_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyBatchCheckV2 = function(arg) {
  return this.request("files/copy_batch/check_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyBatchCheck = function(arg) {
  return this.request("files/copy_batch/check", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyReferenceGet = function(arg) {
  return this.request("files/copy_reference/get", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCopyReferenceSave = function(arg) {
  return this.request("files/copy_reference/save", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCreateFolderV2 = function(arg) {
  return this.request("files/create_folder_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCreateFolder = function(arg) {
  return this.request("files/create_folder", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCreateFolderBatch = function(arg) {
  return this.request("files/create_folder_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesCreateFolderBatchCheck = function(arg) {
  return this.request("files/create_folder_batch/check", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesDeleteV2 = function(arg) {
  return this.request("files/delete_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesDelete = function(arg) {
  return this.request("files/delete", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesDeleteBatch = function(arg) {
  return this.request("files/delete_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesDeleteBatchCheck = function(arg) {
  return this.request("files/delete_batch/check", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesDownload = function(arg) {
  return this.request("files/download", arg, "user", "content", "download", "files.content.read");
};
routes.filesDownloadZip = function(arg) {
  return this.request("files/download_zip", arg, "user", "content", "download", "files.content.read");
};
routes.filesExport = function(arg) {
  return this.request("files/export", arg, "user", "content", "download", "files.content.read");
};
routes.filesGetFileLockBatch = function(arg) {
  return this.request("files/get_file_lock_batch", arg, "user", "api", "rpc", "files.content.read");
};
routes.filesGetMetadata = function(arg) {
  return this.request("files/get_metadata", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesGetPreview = function(arg) {
  return this.request("files/get_preview", arg, "user", "content", "download", "files.content.read");
};
routes.filesGetTemporaryLink = function(arg) {
  return this.request("files/get_temporary_link", arg, "user", "api", "rpc", "files.content.read");
};
routes.filesGetTemporaryUploadLink = function(arg) {
  return this.request("files/get_temporary_upload_link", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesGetThumbnail = function(arg) {
  return this.request("files/get_thumbnail", arg, "user", "content", "download", "files.content.read");
};
routes.filesGetThumbnailV2 = function(arg) {
  return this.request("files/get_thumbnail_v2", arg, "app, user", "content", "download", "files.content.read");
};
routes.filesGetThumbnailBatch = function(arg) {
  return this.request("files/get_thumbnail_batch", arg, "user", "content", "rpc", "files.content.read");
};
routes.filesListFolder = function(arg) {
  return this.request("files/list_folder", arg, "app, user", "api", "rpc", "files.metadata.read");
};
routes.filesListFolderContinue = function(arg) {
  return this.request("files/list_folder/continue", arg, "app, user", "api", "rpc", "files.metadata.read");
};
routes.filesListFolderGetLatestCursor = function(arg) {
  return this.request("files/list_folder/get_latest_cursor", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesListFolderLongpoll = function(arg) {
  return this.request("files/list_folder/longpoll", arg, "noauth", "notify", "rpc", "files.metadata.read");
};
routes.filesListRevisions = function(arg) {
  return this.request("files/list_revisions", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesLockFileBatch = function(arg) {
  return this.request("files/lock_file_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMoveV2 = function(arg) {
  return this.request("files/move_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMove = function(arg) {
  return this.request("files/move", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMoveBatchV2 = function(arg) {
  return this.request("files/move_batch_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMoveBatch = function(arg) {
  return this.request("files/move_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMoveBatchCheckV2 = function(arg) {
  return this.request("files/move_batch/check_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesMoveBatchCheck = function(arg) {
  return this.request("files/move_batch/check", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesPaperCreate = function(arg) {
  return this.request("files/paper/create", arg, "user", "api", "upload", "files.content.write");
};
routes.filesPaperUpdate = function(arg) {
  return this.request("files/paper/update", arg, "user", "api", "upload", "files.content.write");
};
routes.filesPermanentlyDelete = function(arg) {
  return this.request("files/permanently_delete", arg, "user", "api", "rpc", "files.permanent_delete");
};
routes.filesPropertiesAdd = function(arg) {
  return this.request("files/properties/add", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesPropertiesOverwrite = function(arg) {
  return this.request("files/properties/overwrite", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesPropertiesRemove = function(arg) {
  return this.request("files/properties/remove", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesPropertiesTemplateGet = function(arg) {
  return this.request("files/properties/template/get", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesPropertiesTemplateList = function() {
  return this.request("files/properties/template/list", null, "user", "api", "rpc", "files.metadata.read");
};
routes.filesPropertiesUpdate = function(arg) {
  return this.request("files/properties/update", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesRestore = function(arg) {
  return this.request("files/restore", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesSaveUrl = function(arg) {
  return this.request("files/save_url", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesSaveUrlCheckJobStatus = function(arg) {
  return this.request("files/save_url/check_job_status", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesSearch = function(arg) {
  return this.request("files/search", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesSearchV2 = function(arg) {
  return this.request("files/search_v2", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesSearchContinueV2 = function(arg) {
  return this.request("files/search/continue_v2", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesTagsAdd = function(arg) {
  return this.request("files/tags/add", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesTagsGet = function(arg) {
  return this.request("files/tags/get", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.filesTagsRemove = function(arg) {
  return this.request("files/tags/remove", arg, "user", "api", "rpc", "files.metadata.write");
};
routes.filesUnlockFileBatch = function(arg) {
  return this.request("files/unlock_file_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesUpload = function(arg) {
  return this.request("files/upload", arg, "user", "content", "upload", "files.content.write");
};
routes.filesUploadSessionAppendV2 = function(arg) {
  return this.request("files/upload_session/append_v2", arg, "user", "content", "upload", "files.content.write");
};
routes.filesUploadSessionAppend = function(arg) {
  return this.request("files/upload_session/append", arg, "user", "content", "upload", "files.content.write");
};
routes.filesUploadSessionFinish = function(arg) {
  return this.request("files/upload_session/finish", arg, "user", "content", "upload", "files.content.write");
};
routes.filesUploadSessionFinishBatch = function(arg) {
  return this.request("files/upload_session/finish_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesUploadSessionFinishBatchV2 = function(arg) {
  return this.request("files/upload_session/finish_batch_v2", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesUploadSessionFinishBatchCheck = function(arg) {
  return this.request("files/upload_session/finish_batch/check", arg, "user", "api", "rpc", "files.content.write");
};
routes.filesUploadSessionStart = function(arg) {
  return this.request("files/upload_session/start", arg, "user", "content", "upload", "files.content.write");
};
routes.filesUploadSessionStartBatch = function(arg) {
  return this.request("files/upload_session/start_batch", arg, "user", "api", "rpc", "files.content.write");
};
routes.openidUserinfo = function(arg) {
  return this.request("openid/userinfo", arg, "user", "api", "rpc", "openid");
};
routes.paperDocsArchive = function(arg) {
  return this.request("paper/docs/archive", arg, "user", "api", "rpc", "files.content.write");
};
routes.paperDocsCreate = function(arg) {
  return this.request("paper/docs/create", arg, "user", "api", "upload", "files.content.write");
};
routes.paperDocsDownload = function(arg) {
  return this.request("paper/docs/download", arg, "user", "api", "download", "files.content.read");
};
routes.paperDocsFolderUsersList = function(arg) {
  return this.request("paper/docs/folder_users/list", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsFolderUsersListContinue = function(arg) {
  return this.request("paper/docs/folder_users/list/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsGetFolderInfo = function(arg) {
  return this.request("paper/docs/get_folder_info", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsList = function(arg) {
  return this.request("paper/docs/list", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.paperDocsListContinue = function(arg) {
  return this.request("paper/docs/list/continue", arg, "user", "api", "rpc", "files.metadata.read");
};
routes.paperDocsPermanentlyDelete = function(arg) {
  return this.request("paper/docs/permanently_delete", arg, "user", "api", "rpc", "files.permanent_delete");
};
routes.paperDocsSharingPolicyGet = function(arg) {
  return this.request("paper/docs/sharing_policy/get", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsSharingPolicySet = function(arg) {
  return this.request("paper/docs/sharing_policy/set", arg, "user", "api", "rpc", "sharing.write");
};
routes.paperDocsUpdate = function(arg) {
  return this.request("paper/docs/update", arg, "user", "api", "upload", "files.content.write");
};
routes.paperDocsUsersAdd = function(arg) {
  return this.request("paper/docs/users/add", arg, "user", "api", "rpc", "sharing.write");
};
routes.paperDocsUsersList = function(arg) {
  return this.request("paper/docs/users/list", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsUsersListContinue = function(arg) {
  return this.request("paper/docs/users/list/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.paperDocsUsersRemove = function(arg) {
  return this.request("paper/docs/users/remove", arg, "user", "api", "rpc", "sharing.write");
};
routes.paperFoldersCreate = function(arg) {
  return this.request("paper/folders/create", arg, "user", "api", "rpc", "files.content.write");
};
routes.sharingAddFileMember = function(arg) {
  return this.request("sharing/add_file_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingAddFolderMember = function(arg) {
  return this.request("sharing/add_folder_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingCheckJobStatus = function(arg) {
  return this.request("sharing/check_job_status", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingCheckRemoveMemberJobStatus = function(arg) {
  return this.request("sharing/check_remove_member_job_status", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingCheckShareJobStatus = function(arg) {
  return this.request("sharing/check_share_job_status", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingCreateSharedLink = function(arg) {
  return this.request("sharing/create_shared_link", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingCreateSharedLinkWithSettings = function(arg) {
  return this.request("sharing/create_shared_link_with_settings", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingGetFileMetadata = function(arg) {
  return this.request("sharing/get_file_metadata", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingGetFileMetadataBatch = function(arg) {
  return this.request("sharing/get_file_metadata/batch", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingGetFolderMetadata = function(arg) {
  return this.request("sharing/get_folder_metadata", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingGetSharedLinkFile = function(arg) {
  return this.request("sharing/get_shared_link_file", arg, "user", "content", "download", "sharing.read");
};
routes.sharingGetSharedLinkMetadata = function(arg) {
  return this.request("sharing/get_shared_link_metadata", arg, "app, user", "api", "rpc", "sharing.read");
};
routes.sharingGetSharedLinks = function(arg) {
  return this.request("sharing/get_shared_links", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFileMembers = function(arg) {
  return this.request("sharing/list_file_members", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFileMembersBatch = function(arg) {
  return this.request("sharing/list_file_members/batch", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFileMembersContinue = function(arg) {
  return this.request("sharing/list_file_members/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFolderMembers = function(arg) {
  return this.request("sharing/list_folder_members", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFolderMembersContinue = function(arg) {
  return this.request("sharing/list_folder_members/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFolders = function(arg) {
  return this.request("sharing/list_folders", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListFoldersContinue = function(arg) {
  return this.request("sharing/list_folders/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListMountableFolders = function(arg) {
  return this.request("sharing/list_mountable_folders", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListMountableFoldersContinue = function(arg) {
  return this.request("sharing/list_mountable_folders/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListReceivedFiles = function(arg) {
  return this.request("sharing/list_received_files", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListReceivedFilesContinue = function(arg) {
  return this.request("sharing/list_received_files/continue", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingListSharedLinks = function(arg) {
  return this.request("sharing/list_shared_links", arg, "user", "api", "rpc", "sharing.read");
};
routes.sharingModifySharedLinkSettings = function(arg) {
  return this.request("sharing/modify_shared_link_settings", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingMountFolder = function(arg) {
  return this.request("sharing/mount_folder", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRelinquishFileMembership = function(arg) {
  return this.request("sharing/relinquish_file_membership", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRelinquishFolderMembership = function(arg) {
  return this.request("sharing/relinquish_folder_membership", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRemoveFileMember = function(arg) {
  return this.request("sharing/remove_file_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRemoveFileMember2 = function(arg) {
  return this.request("sharing/remove_file_member_2", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRemoveFolderMember = function(arg) {
  return this.request("sharing/remove_folder_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingRevokeSharedLink = function(arg) {
  return this.request("sharing/revoke_shared_link", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingSetAccessInheritance = function(arg) {
  return this.request("sharing/set_access_inheritance", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingShareFolder = function(arg) {
  return this.request("sharing/share_folder", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingTransferFolder = function(arg) {
  return this.request("sharing/transfer_folder", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUnmountFolder = function(arg) {
  return this.request("sharing/unmount_folder", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUnshareFile = function(arg) {
  return this.request("sharing/unshare_file", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUnshareFolder = function(arg) {
  return this.request("sharing/unshare_folder", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUpdateFileMember = function(arg) {
  return this.request("sharing/update_file_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUpdateFolderMember = function(arg) {
  return this.request("sharing/update_folder_member", arg, "user", "api", "rpc", "sharing.write");
};
routes.sharingUpdateFolderPolicy = function(arg) {
  return this.request("sharing/update_folder_policy", arg, "user", "api", "rpc", "sharing.write");
};
routes.teamDevicesListMemberDevices = function(arg) {
  return this.request("team/devices/list_member_devices", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamDevicesListMembersDevices = function(arg) {
  return this.request("team/devices/list_members_devices", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamDevicesListTeamDevices = function(arg) {
  return this.request("team/devices/list_team_devices", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamDevicesRevokeDeviceSession = function(arg) {
  return this.request("team/devices/revoke_device_session", arg, "team", "api", "rpc", "sessions.modify");
};
routes.teamDevicesRevokeDeviceSessionBatch = function(arg) {
  return this.request("team/devices/revoke_device_session_batch", arg, "team", "api", "rpc", "sessions.modify");
};
routes.teamFeaturesGetValues = function(arg) {
  return this.request("team/features/get_values", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamGetInfo = function() {
  return this.request("team/get_info", null, "team", "api", "rpc", "team_info.read");
};
routes.teamGroupsCreate = function(arg) {
  return this.request("team/groups/create", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsDelete = function(arg) {
  return this.request("team/groups/delete", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsGetInfo = function(arg) {
  return this.request("team/groups/get_info", arg, "team", "api", "rpc", "groups.read");
};
routes.teamGroupsJobStatusGet = function(arg) {
  return this.request("team/groups/job_status/get", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsList = function(arg) {
  return this.request("team/groups/list", arg, "team", "api", "rpc", "groups.read");
};
routes.teamGroupsListContinue = function(arg) {
  return this.request("team/groups/list/continue", arg, "team", "api", "rpc", "groups.read");
};
routes.teamGroupsMembersAdd = function(arg) {
  return this.request("team/groups/members/add", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsMembersList = function(arg) {
  return this.request("team/groups/members/list", arg, "team", "api", "rpc", "groups.read");
};
routes.teamGroupsMembersListContinue = function(arg) {
  return this.request("team/groups/members/list/continue", arg, "team", "api", "rpc", "groups.read");
};
routes.teamGroupsMembersRemove = function(arg) {
  return this.request("team/groups/members/remove", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsMembersSetAccessType = function(arg) {
  return this.request("team/groups/members/set_access_type", arg, "team", "api", "rpc", "groups.write");
};
routes.teamGroupsUpdate = function(arg) {
  return this.request("team/groups/update", arg, "team", "api", "rpc", "groups.write");
};
routes.teamLegalHoldsCreatePolicy = function(arg) {
  return this.request("team/legal_holds/create_policy", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsGetPolicy = function(arg) {
  return this.request("team/legal_holds/get_policy", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsListHeldRevisions = function(arg) {
  return this.request("team/legal_holds/list_held_revisions", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsListHeldRevisionsContinue = function(arg) {
  return this.request("team/legal_holds/list_held_revisions_continue", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsListPolicies = function(arg) {
  return this.request("team/legal_holds/list_policies", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsReleasePolicy = function(arg) {
  return this.request("team/legal_holds/release_policy", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLegalHoldsUpdatePolicy = function(arg) {
  return this.request("team/legal_holds/update_policy", arg, "team", "api", "rpc", "team_data.governance.write");
};
routes.teamLinkedAppsListMemberLinkedApps = function(arg) {
  return this.request("team/linked_apps/list_member_linked_apps", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamLinkedAppsListMembersLinkedApps = function(arg) {
  return this.request("team/linked_apps/list_members_linked_apps", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamLinkedAppsListTeamLinkedApps = function(arg) {
  return this.request("team/linked_apps/list_team_linked_apps", arg, "team", "api", "rpc", "sessions.list");
};
routes.teamLinkedAppsRevokeLinkedApp = function(arg) {
  return this.request("team/linked_apps/revoke_linked_app", arg, "team", "api", "rpc", "sessions.modify");
};
routes.teamLinkedAppsRevokeLinkedAppBatch = function(arg) {
  return this.request("team/linked_apps/revoke_linked_app_batch", arg, "team", "api", "rpc", "sessions.modify");
};
routes.teamMemberSpaceLimitsExcludedUsersAdd = function(arg) {
  return this.request("team/member_space_limits/excluded_users/add", arg, "team", "api", "rpc", "members.write");
};
routes.teamMemberSpaceLimitsExcludedUsersList = function(arg) {
  return this.request("team/member_space_limits/excluded_users/list", arg, "team", "api", "rpc", "members.read");
};
routes.teamMemberSpaceLimitsExcludedUsersListContinue = function(arg) {
  return this.request("team/member_space_limits/excluded_users/list/continue", arg, "team", "api", "rpc", "members.read");
};
routes.teamMemberSpaceLimitsExcludedUsersRemove = function(arg) {
  return this.request("team/member_space_limits/excluded_users/remove", arg, "team", "api", "rpc", "members.write");
};
routes.teamMemberSpaceLimitsGetCustomQuota = function(arg) {
  return this.request("team/member_space_limits/get_custom_quota", arg, "team", "api", "rpc", "members.read");
};
routes.teamMemberSpaceLimitsRemoveCustomQuota = function(arg) {
  return this.request("team/member_space_limits/remove_custom_quota", arg, "team", "api", "rpc", "members.write");
};
routes.teamMemberSpaceLimitsSetCustomQuota = function(arg) {
  return this.request("team/member_space_limits/set_custom_quota", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersAddV2 = function(arg) {
  return this.request("team/members/add_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersAdd = function(arg) {
  return this.request("team/members/add", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersAddJobStatusGetV2 = function(arg) {
  return this.request("team/members/add/job_status/get_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersAddJobStatusGet = function(arg) {
  return this.request("team/members/add/job_status/get", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersDeleteProfilePhotoV2 = function(arg) {
  return this.request("team/members/delete_profile_photo_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersDeleteProfilePhoto = function(arg) {
  return this.request("team/members/delete_profile_photo", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersGetAvailableTeamMemberRoles = function() {
  return this.request("team/members/get_available_team_member_roles", null, "team", "api", "rpc", "members.read");
};
routes.teamMembersGetInfoV2 = function(arg) {
  return this.request("team/members/get_info_v2", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersGetInfo = function(arg) {
  return this.request("team/members/get_info", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersListV2 = function(arg) {
  return this.request("team/members/list_v2", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersList = function(arg) {
  return this.request("team/members/list", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersListContinueV2 = function(arg) {
  return this.request("team/members/list/continue_v2", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersListContinue = function(arg) {
  return this.request("team/members/list/continue", arg, "team", "api", "rpc", "members.read");
};
routes.teamMembersMoveFormerMemberFiles = function(arg) {
  return this.request("team/members/move_former_member_files", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersMoveFormerMemberFilesJobStatusCheck = function(arg) {
  return this.request("team/members/move_former_member_files/job_status/check", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersRecover = function(arg) {
  return this.request("team/members/recover", arg, "team", "api", "rpc", "members.delete");
};
routes.teamMembersRemove = function(arg) {
  return this.request("team/members/remove", arg, "team", "api", "rpc", "members.delete");
};
routes.teamMembersRemoveJobStatusGet = function(arg) {
  return this.request("team/members/remove/job_status/get", arg, "team", "api", "rpc", "members.delete");
};
routes.teamMembersSecondaryEmailsAdd = function(arg) {
  return this.request("team/members/secondary_emails/add", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSecondaryEmailsDelete = function(arg) {
  return this.request("team/members/secondary_emails/delete", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSecondaryEmailsResendVerificationEmails = function(arg) {
  return this.request("team/members/secondary_emails/resend_verification_emails", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSendWelcomeEmail = function(arg) {
  return this.request("team/members/send_welcome_email", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetAdminPermissionsV2 = function(arg) {
  return this.request("team/members/set_admin_permissions_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetAdminPermissions = function(arg) {
  return this.request("team/members/set_admin_permissions", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetProfileV2 = function(arg) {
  return this.request("team/members/set_profile_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetProfile = function(arg) {
  return this.request("team/members/set_profile", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetProfilePhotoV2 = function(arg) {
  return this.request("team/members/set_profile_photo_v2", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSetProfilePhoto = function(arg) {
  return this.request("team/members/set_profile_photo", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersSuspend = function(arg) {
  return this.request("team/members/suspend", arg, "team", "api", "rpc", "members.write");
};
routes.teamMembersUnsuspend = function(arg) {
  return this.request("team/members/unsuspend", arg, "team", "api", "rpc", "members.write");
};
routes.teamNamespacesList = function(arg) {
  return this.request("team/namespaces/list", arg, "team", "api", "rpc", "team_data.member");
};
routes.teamNamespacesListContinue = function(arg) {
  return this.request("team/namespaces/list/continue", arg, "team", "api", "rpc", "team_data.member");
};
routes.teamPropertiesTemplateAdd = function(arg) {
  return this.request("team/properties/template/add", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.teamPropertiesTemplateGet = function(arg) {
  return this.request("team/properties/template/get", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.teamPropertiesTemplateList = function() {
  return this.request("team/properties/template/list", null, "team", "api", "rpc", "files.team_metadata.write");
};
routes.teamPropertiesTemplateUpdate = function(arg) {
  return this.request("team/properties/template/update", arg, "team", "api", "rpc", "files.team_metadata.write");
};
routes.teamReportsGetActivity = function(arg) {
  return this.request("team/reports/get_activity", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamReportsGetDevices = function(arg) {
  return this.request("team/reports/get_devices", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamReportsGetMembership = function(arg) {
  return this.request("team/reports/get_membership", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamReportsGetStorage = function(arg) {
  return this.request("team/reports/get_storage", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamSharingAllowlistAdd = function(arg) {
  return this.request("team/sharing_allowlist/add", arg, "team", "api", "rpc", "team_info.write");
};
routes.teamSharingAllowlistList = function(arg) {
  return this.request("team/sharing_allowlist/list", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamSharingAllowlistListContinue = function(arg) {
  return this.request("team/sharing_allowlist/list/continue", arg, "team", "api", "rpc", "team_info.read");
};
routes.teamSharingAllowlistRemove = function(arg) {
  return this.request("team/sharing_allowlist/remove", arg, "team", "api", "rpc", "team_info.write");
};
routes.teamTeamFolderActivate = function(arg) {
  return this.request("team/team_folder/activate", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderArchive = function(arg) {
  return this.request("team/team_folder/archive", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderArchiveCheck = function(arg) {
  return this.request("team/team_folder/archive/check", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderCreate = function(arg) {
  return this.request("team/team_folder/create", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderGetInfo = function(arg) {
  return this.request("team/team_folder/get_info", arg, "team", "api", "rpc", "team_data.content.read");
};
routes.teamTeamFolderList = function(arg) {
  return this.request("team/team_folder/list", arg, "team", "api", "rpc", "team_data.content.read");
};
routes.teamTeamFolderListContinue = function(arg) {
  return this.request("team/team_folder/list/continue", arg, "team", "api", "rpc", "team_data.content.read");
};
routes.teamTeamFolderPermanentlyDelete = function(arg) {
  return this.request("team/team_folder/permanently_delete", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderRename = function(arg) {
  return this.request("team/team_folder/rename", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTeamFolderUpdateSyncSettings = function(arg) {
  return this.request("team/team_folder/update_sync_settings", arg, "team", "api", "rpc", "team_data.content.write");
};
routes.teamTokenGetAuthenticatedAdmin = function() {
  return this.request("team/token/get_authenticated_admin", null, "team", "api", "rpc", "team_info.read");
};
routes.teamLogGetEvents = function(arg) {
  return this.request("team_log/get_events", arg, "team", "api", "rpc", "events.read");
};
routes.teamLogGetEventsContinue = function(arg) {
  return this.request("team_log/get_events/continue", arg, "team", "api", "rpc", "events.read");
};
routes.usersFeaturesGetValues = function(arg) {
  return this.request("users/features/get_values", arg, "user", "api", "rpc", "account_info.read");
};
routes.usersGetAccount = function(arg) {
  return this.request("users/get_account", arg, "user", "api", "rpc", "sharing.read");
};
routes.usersGetAccountBatch = function(arg) {
  return this.request("users/get_account_batch", arg, "user", "api", "rpc", "sharing.read");
};
routes.usersGetCurrentAccount = function() {
  return this.request("users/get_current_account", null, "user", "api", "rpc", "account_info.read");
};
routes.usersGetSpaceUsage = function() {
  return this.request("users/get_space_usage", null, "user", "api", "rpc", "account_info.read");
};

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/utils.js
function getSafeUnicode(c) {
  var unicode = "000".concat(c.charCodeAt(0).toString(16)).slice(-4);
  return "\\u".concat(unicode);
}
var baseApiUrl = function baseApiUrl2(subdomain) {
  var domain = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_API_DOMAIN;
  var domainDelimiter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!domainDelimiter) {
    return "https://".concat(domain, "/2/");
  }
  if (domain !== DEFAULT_API_DOMAIN && TEST_DOMAIN_MAPPINGS[subdomain] !== void 0) {
    subdomain = TEST_DOMAIN_MAPPINGS[subdomain];
    domainDelimiter = "-";
  }
  return "https://".concat(subdomain).concat(domainDelimiter).concat(domain, "/2/");
};
var OAuth2AuthorizationUrl = function OAuth2AuthorizationUrl2() {
  var domain = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_DOMAIN;
  if (domain !== DEFAULT_DOMAIN) {
    domain = "meta-".concat(domain);
  }
  return "https://".concat(domain, "/oauth2/authorize");
};
var OAuth2TokenUrl = function OAuth2TokenUrl2() {
  var domain = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_API_DOMAIN;
  var domainDelimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ".";
  var subdomain = "api";
  if (domain !== DEFAULT_API_DOMAIN) {
    subdomain = TEST_DOMAIN_MAPPINGS[subdomain];
    domainDelimiter = "-";
  }
  return "https://".concat(subdomain).concat(domainDelimiter).concat(domain, "/oauth2/token");
};
function httpHeaderSafeJson(args) {
  return JSON.stringify(args).replace(/[\u007f-\uffff]/g, getSafeUnicode);
}
function getTokenExpiresAtDate(expiresIn) {
  return new Date(Date.now() + expiresIn * 1e3);
}
function isWindowOrWorker() {
  return typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope || typeof module === "undefined" || typeof window !== "undefined";
}
function isBrowserEnv() {
  return typeof window !== "undefined";
}
function isWorkerEnv() {
  return typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
}
function createBrowserSafeString(toBeConverted) {
  var convertedString = toBeConverted.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  return convertedString;
}

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/error.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var DropboxResponseError = /* @__PURE__ */ function(_Error) {
  _inherits(DropboxResponseError2, _Error);
  var _super = _createSuper(DropboxResponseError2);
  function DropboxResponseError2(status, headers, error) {
    var _this;
    _classCallCheck(this, DropboxResponseError2);
    _this = _super.call(this, "Response failed with a ".concat(status, " code"));
    _this.name = "DropboxResponseError";
    _this.status = status;
    _this.headers = headers;
    _this.error = error;
    return _this;
  }
  return DropboxResponseError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/response.js
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var DropboxResponse = function DropboxResponse2(status, headers, result) {
  _classCallCheck2(this, DropboxResponse2);
  this.status = status;
  this.headers = headers;
  this.result = result;
};
function throwAsError(res) {
  return res.text().then(function(data) {
    var errorObject;
    try {
      errorObject = JSON.parse(data);
    } catch (error) {
      errorObject = data;
    }
    throw new DropboxResponseError(res.status, res.headers, errorObject);
  });
}
function parseResponse(res) {
  if (!res.ok) {
    return throwAsError(res);
  }
  return res.text().then(function(data) {
    var responseObject;
    try {
      responseObject = JSON.parse(data);
    } catch (error) {
      responseObject = data;
    }
    return new DropboxResponse(res.status, res.headers, responseObject);
  });
}
function parseDownloadResponse(res) {
  if (!res.ok) {
    return throwAsError(res);
  }
  return new Promise(function(resolve) {
    if (isWindowOrWorker()) {
      res.blob().then(function(data) {
        return resolve(data);
      });
    } else {
      res.buffer().then(function(data) {
        return resolve(data);
      });
    }
  }).then(function(data) {
    var result = JSON.parse(res.headers.get("dropbox-api-result"));
    if (isWindowOrWorker()) {
      result.fileBlob = data;
    } else {
      result.fileBinary = data;
    }
    return new DropboxResponse(res.status, res.headers, result);
  });
}

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/auth.js
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
var fetch;
var crypto;
var Encoder;
var TokenExpirationBuffer = 300 * 1e3;
var PKCELength = 128;
var TokenAccessTypes = ["legacy", "offline", "online"];
var GrantTypes = ["code", "token"];
var IncludeGrantedScopes = ["none", "user", "team"];
var DropboxAuth = /* @__PURE__ */ function() {
  function DropboxAuth2(options) {
    _classCallCheck3(this, DropboxAuth2);
    options = options || {};
    if (isBrowserEnv()) {
      fetch = window.fetch.bind(window);
      crypto = window.crypto || window.msCrypto;
    } else if (isWorkerEnv()) {
      fetch = self.fetch.bind(self);
      crypto = self.crypto;
    } else {
      fetch = require_browser();
      crypto = require_crypto();
    }
    if (typeof TextEncoder === "undefined") {
      Encoder = require_util().TextEncoder;
    } else {
      Encoder = TextEncoder;
    }
    this.fetch = options.fetch || fetch;
    this.accessToken = options.accessToken;
    this.accessTokenExpiresAt = options.accessTokenExpiresAt;
    this.refreshToken = options.refreshToken;
    this.clientId = options.clientId;
    this.clientSecret = options.clientSecret;
    this.domain = options.domain;
    this.domainDelimiter = options.domainDelimiter;
    this.customHeaders = options.customHeaders;
    this.dataOnBody = options.dataOnBody;
  }
  _createClass(DropboxAuth2, [{
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      this.accessToken = accessToken;
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.accessToken;
    }
  }, {
    key: "setClientId",
    value: function setClientId(clientId) {
      this.clientId = clientId;
    }
  }, {
    key: "getClientId",
    value: function getClientId() {
      return this.clientId;
    }
  }, {
    key: "setClientSecret",
    value: function setClientSecret(clientSecret) {
      this.clientSecret = clientSecret;
    }
  }, {
    key: "getClientSecret",
    value: function getClientSecret() {
      return this.clientSecret;
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return this.refreshToken;
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(refreshToken) {
      this.refreshToken = refreshToken;
    }
  }, {
    key: "getAccessTokenExpiresAt",
    value: function getAccessTokenExpiresAt() {
      return this.accessTokenExpiresAt;
    }
  }, {
    key: "setAccessTokenExpiresAt",
    value: function setAccessTokenExpiresAt(accessTokenExpiresAt) {
      this.accessTokenExpiresAt = accessTokenExpiresAt;
    }
  }, {
    key: "setCodeVerifier",
    value: function setCodeVerifier(codeVerifier) {
      this.codeVerifier = codeVerifier;
    }
  }, {
    key: "getCodeVerifier",
    value: function getCodeVerifier() {
      return this.codeVerifier;
    }
  }, {
    key: "generateCodeChallenge",
    value: function generateCodeChallenge() {
      var _this = this;
      var encoder = new Encoder();
      var codeData = encoder.encode(this.codeVerifier);
      var codeChallenge;
      if (isBrowserEnv() || isWorkerEnv()) {
        return crypto.subtle.digest("SHA-256", codeData).then(function(digestedHash2) {
          var base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(digestedHash2)));
          codeChallenge = createBrowserSafeString(base64String).substr(0, 128);
          _this.codeChallenge = codeChallenge;
        });
      }
      var digestedHash = crypto.createHash("sha256").update(codeData).digest();
      codeChallenge = createBrowserSafeString(digestedHash);
      this.codeChallenge = codeChallenge;
      return Promise.resolve();
    }
  }, {
    key: "generatePKCECodes",
    value: function generatePKCECodes() {
      var codeVerifier;
      if (isBrowserEnv() || isWorkerEnv()) {
        var array = new Uint8Array(PKCELength);
        var randomValueArray = crypto.getRandomValues(array);
        var base64String = btoa(randomValueArray);
        codeVerifier = createBrowserSafeString(base64String).substr(0, 128);
      } else {
        var randomBytes = crypto.randomBytes(PKCELength);
        codeVerifier = createBrowserSafeString(randomBytes).substr(0, 128);
      }
      this.codeVerifier = codeVerifier;
      return this.generateCodeChallenge();
    }
  }, {
    key: "getAuthenticationUrl",
    value: function getAuthenticationUrl(redirectUri, state) {
      var _this2 = this;
      var authType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "token";
      var tokenAccessType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      var scope = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
      var includeGrantedScopes = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "none";
      var usePKCE = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
      var clientId = this.getClientId();
      var baseUrl = OAuth2AuthorizationUrl(this.domain);
      if (!clientId) {
        throw new Error("A client id is required. You can set the client id using .setClientId().");
      }
      if (authType !== "code" && !redirectUri) {
        throw new Error("A redirect uri is required.");
      }
      if (!GrantTypes.includes(authType)) {
        throw new Error("Authorization type must be code or token");
      }
      if (tokenAccessType && !TokenAccessTypes.includes(tokenAccessType)) {
        throw new Error("Token Access Type must be legacy, offline, or online");
      }
      if (scope && !(scope instanceof Array)) {
        throw new Error("Scope must be an array of strings");
      }
      if (!IncludeGrantedScopes.includes(includeGrantedScopes)) {
        throw new Error("includeGrantedScopes must be none, user, or team");
      }
      var authUrl;
      if (authType === "code") {
        authUrl = "".concat(baseUrl, "?response_type=code&client_id=").concat(clientId);
      } else {
        authUrl = "".concat(baseUrl, "?response_type=token&client_id=").concat(clientId);
      }
      if (redirectUri) {
        authUrl += "&redirect_uri=".concat(redirectUri);
      }
      if (state) {
        authUrl += "&state=".concat(state);
      }
      if (tokenAccessType) {
        authUrl += "&token_access_type=".concat(tokenAccessType);
      }
      if (scope) {
        authUrl += "&scope=".concat(scope.join(" "));
      }
      if (includeGrantedScopes !== "none") {
        authUrl += "&include_granted_scopes=".concat(includeGrantedScopes);
      }
      if (usePKCE) {
        return this.generatePKCECodes().then(function() {
          authUrl += "&code_challenge_method=S256";
          authUrl += "&code_challenge=".concat(_this2.codeChallenge);
          return authUrl;
        });
      }
      return Promise.resolve(authUrl);
    }
  }, {
    key: "getAccessTokenFromCode",
    value: function getAccessTokenFromCode(redirectUri, code) {
      var clientId = this.getClientId();
      var clientSecret = this.getClientSecret();
      if (!clientId) {
        throw new Error("A client id is required. You can set the client id using .setClientId().");
      }
      var path = OAuth2TokenUrl(this.domain, this.domainDelimiter);
      path += "?grant_type=authorization_code";
      path += "&code=".concat(code);
      path += "&client_id=".concat(clientId);
      if (clientSecret) {
        path += "&client_secret=".concat(clientSecret);
      } else {
        if (!this.codeVerifier) {
          throw new Error("You must use PKCE when generating the authorization URL to not include a client secret");
        }
        path += "&code_verifier=".concat(this.codeVerifier);
      }
      if (redirectUri) {
        path += "&redirect_uri=".concat(redirectUri);
      }
      var fetchOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      return this.fetch(path, fetchOptions).then(function(res) {
        return parseResponse(res);
      });
    }
  }, {
    key: "checkAndRefreshAccessToken",
    value: function checkAndRefreshAccessToken() {
      var canRefresh = this.getRefreshToken() && this.getClientId();
      var needsRefresh = !this.getAccessTokenExpiresAt() || new Date(Date.now() + TokenExpirationBuffer) >= this.getAccessTokenExpiresAt();
      var needsToken = !this.getAccessToken();
      if ((needsRefresh || needsToken) && canRefresh) {
        return this.refreshAccessToken();
      }
      return Promise.resolve();
    }
  }, {
    key: "refreshAccessToken",
    value: function refreshAccessToken() {
      var _this3 = this;
      var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      var clientId = this.getClientId();
      var clientSecret = this.getClientSecret();
      if (!clientId) {
        throw new Error("A client id is required. You can set the client id using .setClientId().");
      }
      if (scope && !(scope instanceof Array)) {
        throw new Error("Scope must be an array of strings");
      }
      var refreshUrl = OAuth2TokenUrl(this.domain, this.domainDelimiter);
      var fetchOptions = {
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST"
      };
      if (this.dataOnBody) {
        var body = {
          grant_type: "refresh_token",
          client_id: clientId,
          refresh_token: this.getRefreshToken()
        };
        if (clientSecret) {
          body.client_secret = clientSecret;
        }
        if (scope) {
          body.scope = scope.join(" ");
        }
        fetchOptions.body = body;
      } else {
        refreshUrl += "?grant_type=refresh_token&refresh_token=".concat(this.getRefreshToken());
        refreshUrl += "&client_id=".concat(clientId);
        if (clientSecret) {
          refreshUrl += "&client_secret=".concat(clientSecret);
        }
        if (scope) {
          refreshUrl += "&scope=".concat(scope.join(" "));
        }
      }
      return this.fetch(refreshUrl, fetchOptions).then(function(res) {
        return parseResponse(res);
      }).then(function(res) {
        _this3.setAccessToken(res.result.access_token);
        _this3.setAccessTokenExpiresAt(getTokenExpiresAtDate(res.result.expires_in));
      });
    }
  }]);
  return DropboxAuth2;
}();

// node_modules/.pnpm/dropbox@10.33.0/node_modules/dropbox/es/src/dropbox.js
function _classCallCheck4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  return Constructor;
}
var b64 = typeof btoa === "undefined" ? function(str) {
  return Buffer.from(str).toString("base64");
} : btoa;
var Dropbox = /* @__PURE__ */ function() {
  function Dropbox2(options) {
    _classCallCheck4(this, Dropbox2);
    options = options || {};
    if (options.auth) {
      this.auth = options.auth;
    } else {
      this.auth = new DropboxAuth(options);
    }
    this.fetch = options.fetch || this.auth.fetch;
    this.selectUser = options.selectUser;
    this.selectAdmin = options.selectAdmin;
    this.pathRoot = options.pathRoot;
    this.domain = options.domain || this.auth.domain;
    this.domainDelimiter = options.domainDelimiter || this.auth.domainDelimiter;
    this.customHeaders = options.customHeaders || this.auth.customHeaders;
    Object.assign(this, routes);
  }
  _createClass2(Dropbox2, [{
    key: "request",
    value: function request(path, args, auth, host, style) {
      switch (style) {
        case RPC:
          return this.rpcRequest(path, args, auth, host);
        case DOWNLOAD:
          return this.downloadRequest(path, args, auth, host);
        case UPLOAD:
          return this.uploadRequest(path, args, auth, host);
        default:
          throw new Error("Invalid request style: ".concat(style));
      }
    }
  }, {
    key: "rpcRequest",
    value: function rpcRequest(path, body, auth, host) {
      var _this = this;
      return this.auth.checkAndRefreshAccessToken().then(function() {
        var fetchOptions = {
          method: "POST",
          body: body ? JSON.stringify(body) : null,
          headers: {}
        };
        if (body) {
          fetchOptions.headers["Content-Type"] = "application/json";
        }
        _this.setAuthHeaders(auth, fetchOptions);
        _this.setCommonHeaders(fetchOptions);
        return fetchOptions;
      }).then(function(fetchOptions) {
        return _this.fetch(baseApiUrl(host, _this.domain, _this.domainDelimiter) + path, fetchOptions);
      }).then(function(res) {
        return parseResponse(res);
      });
    }
  }, {
    key: "downloadRequest",
    value: function downloadRequest(path, args, auth, host) {
      var _this2 = this;
      return this.auth.checkAndRefreshAccessToken().then(function() {
        var fetchOptions = {
          method: "POST",
          headers: {
            "Dropbox-API-Arg": httpHeaderSafeJson(args)
          }
        };
        _this2.setAuthHeaders(auth, fetchOptions);
        _this2.setCommonHeaders(fetchOptions);
        return fetchOptions;
      }).then(function(fetchOptions) {
        return _this2.fetch(baseApiUrl(host, _this2.domain, _this2.domainDelimiter) + path, fetchOptions);
      }).then(function(res) {
        return parseDownloadResponse(res);
      });
    }
  }, {
    key: "uploadRequest",
    value: function uploadRequest(path, args, auth, host) {
      var _this3 = this;
      return this.auth.checkAndRefreshAccessToken().then(function() {
        var contents = args.contents;
        delete args.contents;
        var fetchOptions = {
          body: contents,
          method: "POST",
          headers: {
            "Content-Type": "application/octet-stream",
            "Dropbox-API-Arg": httpHeaderSafeJson(args)
          }
        };
        _this3.setAuthHeaders(auth, fetchOptions);
        _this3.setCommonHeaders(fetchOptions);
        return fetchOptions;
      }).then(function(fetchOptions) {
        return _this3.fetch(baseApiUrl(host, _this3.domain, _this3.domainDelimiter) + path, fetchOptions);
      }).then(function(res) {
        return parseResponse(res);
      });
    }
  }, {
    key: "setAuthHeaders",
    value: function setAuthHeaders(auth, fetchOptions) {
      if (auth.split(",").length > 1) {
        var authTypes = auth.replace(" ", "").split(",");
        if (authTypes.includes(USER_AUTH) && this.auth.getAccessToken()) {
          auth = USER_AUTH;
        } else if (authTypes.includes(TEAM_AUTH) && this.auth.getAccessToken()) {
          auth = TEAM_AUTH;
        } else if (authTypes.includes(APP_AUTH)) {
          auth = APP_AUTH;
        }
      }
      switch (auth) {
        case APP_AUTH:
          if (this.auth.clientId && this.auth.clientSecret) {
            var authHeader = b64("".concat(this.auth.clientId, ":").concat(this.auth.clientSecret));
            fetchOptions.headers.Authorization = "Basic ".concat(authHeader);
          }
          break;
        case TEAM_AUTH:
        case USER_AUTH:
          if (this.auth.getAccessToken()) {
            fetchOptions.headers.Authorization = "Bearer ".concat(this.auth.getAccessToken());
          }
          break;
        case NO_AUTH:
        case COOKIE:
          break;
        default:
          throw new Error("Unhandled auth type: ".concat(auth));
      }
    }
  }, {
    key: "setCommonHeaders",
    value: function setCommonHeaders(options) {
      var _this4 = this;
      if (this.selectUser) {
        options.headers["Dropbox-API-Select-User"] = this.selectUser;
      }
      if (this.selectAdmin) {
        options.headers["Dropbox-API-Select-Admin"] = this.selectAdmin;
      }
      if (this.pathRoot) {
        options.headers["Dropbox-API-Path-Root"] = this.pathRoot;
      }
      if (this.customHeaders) {
        var headerKeys = Object.keys(this.customHeaders);
        headerKeys.forEach(function(header) {
          options.headers[header] = _this4.customHeaders[header];
        });
      }
    }
  }]);
  return Dropbox2;
}();
export {
  Dropbox,
  DropboxAuth,
  DropboxResponse,
  DropboxResponseError
};
//# sourceMappingURL=dropbox.js.map
